import { makeStyles } from '@material-ui/core/styles';

export const useBadgeStyles = makeStyles(theme => ({
	badge: {
		minWidth: 16,
		height: 16,
		padding: 0,
		top: 11,
		right: 8,
		backgroundColor: theme.palette.primary.main,
		color: theme.palette.common.white
	},
	root: {
		padding: '0px 20px 0px 2px'
	}
}));

export const useStyles = makeStyles(theme => ({
	resetButton: {
		marginTop: 1,
		marginLeft: -theme.spacing(1)
	},
	focusableButton: {
		'&:focus': {
			boxShadow: ''
		}
	}
}));
